import React, { useEffect, useState } from 'react';
import ORBApi from '../../services/ORBApi';
import { Select, InputLabel, FormControl, FormHelperText } from '@mui/material';


export default function LabelsDropDown({
  value,
  onChange,
  className,
  hideEmpty,
  label,
  margin,
  onLoaded,
  error
}) {
  const [labels, setLabels] = useState([]);
  const [selected, setSelected] = useState('');

  useEffect(() => {
    setSelected(value);
  }, [value]);

  useEffect(() => {
    //Load the labels when the component mount
    ORBApi.loadLabels(1, null, 0, 'name', 'asc').then((response) => {
      // Ordena por nome caso a API não tenha ordenado corretamente
      const sortedLabels = [...response.labels].sort((a, b) => {
        return a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' });
      });
      setLabels(sortedLabels);
      if (onLoaded && sortedLabels.length > 0) onLoaded(sortedLabels[0]);
    });
  }, []);

  const onChangeHandler = (e) => {
    setSelected(e.target.value);
    onChange({ id: e.target.value, name: e.target.selectedOptions[0].text });
  };
  return (
    <FormControl
      fullWidth
      error={error}
      margin={margin}
      variant="outlined"
      className={className}
    >
      <InputLabel shrink={selected > 0}>{label}</InputLabel>
      <Select
        native
        label={label}
        onChange={onChangeHandler}
        value={selected}
        notched={selected > 0}
      >
        {!hideEmpty ? <option value="" /> : null}
        {labels.map((label) => {
          return (
            <option key={label.id} value={label.id}>
              {label.name}
            </option>
          );
        })}
      </Select>
      {error && !value && <FormHelperText>Campo obrigatório</FormHelperText>}
    </FormControl>
  );
}
